<app-messages-center-navigation-tree [treeModel]="messagesCenterNavigationService.templatesQueuesTree.nodes"
                                     [selectedNode]="messagesCenterNavigationService.currentQueue">
</app-messages-center-navigation-tree>
